/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
} from './PalReauthCaseManager';

/**
 * 
 * @export
 * @interface CreatePalReauthCaseManager201Response
 */
export interface CreatePalReauthCaseManager201Response {
    /**
     * 
     * @type {PalReauthCaseManager}
     * @memberof CreatePalReauthCaseManager201Response
     */
    data?: PalReauthCaseManager;
}

/**
 * Check if a given object implements the CreatePalReauthCaseManager201Response interface.
 */
export function instanceOfCreatePalReauthCaseManager201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePalReauthCaseManager201ResponseFromJSON(json: any): CreatePalReauthCaseManager201Response {
    return CreatePalReauthCaseManager201ResponseFromJSONTyped(json, false);
}

export function CreatePalReauthCaseManager201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthCaseManager201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalReauthCaseManagerFromJSON(json['data']),
    };
}

export function CreatePalReauthCaseManager201ResponseToJSON(value?: CreatePalReauthCaseManager201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalReauthCaseManagerToJSON(value.data),
    };
}

